<template lang="html">
	<header class="row">
		<div class="logo">
      <router-link to="/">
        <logo />
      </router-link>
		</div>
		<nav class="row">
			<router-link :to="{name: item.uri}" :id="'head-menu-link-' + item.uri.toLowerCase()" class="menu-item" v-for="item in menu" v-bind:key="item.key" v-html="item.name"></router-link>
		</nav>
		<div class="manage row">
			<!-- <div class="ctn-notif" @click="setActive">
				<span class="icon-volet-notif"></span>
				<div v-if="count > 0" class="notif">
					{{ count }}
				</div>
			</div> -->
			<router-link :to="{name: 'Profile'}" class="ctn-profil ctn-profile-picture">
				<img v-img-detect :src="picture" alt="">
			</router-link>
		</div>
	</header>
</template>

<script>
import { mapGetters } from 'vuex'
import Logo from '@/common/components/Logo.vue'

export default {
	props: ['menu'],
	name: 'my-header',
	components: { Logo },
	data () {
		return {
			notifs: [
				{
					key: 0
				}
			]
		}
	},
	methods: {
		setActive () {
			this.$store.commit('OPEN_NOTIF')
		}
	},
	computed: {
		...mapGetters({
			count: 'countNotifs',
			user: 'user',
			theme: 'currentTheme'
		}),
		picture () {
			return (this.user.picture) ? process.env.ASSETS_ROOT + this.user.picture : process.env.API_ROOT + '/assets/user.png'
		}
	}
}
</script>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/common/components/header.vue